import { MiddlewareFunction, redirect } from 'react-router';

import { fetchCurrentUser } from '@/contexts/userContext/util/fetchCurrentUser.util.ts';
import { isApprovedUser } from '@/contexts/userContext/util/isApprovedUser.util.ts';
import { RouteEnum } from '@/models/route/Route.model.ts';
import { hasRouteAccess, isOpenRoute } from '@/models/route/routeAccess.util.ts';

/**
 * Throws a redirect to /forbidden when the current user may not open `path`.
 * Lets the navigation through when there is nothing to check or the user cannot
 * be loaded — UserContextProvider renders the proper error/approval screen in
 * place of the route anyway.
 */
export const assertRouteAccess = async (path: RouteEnum): Promise<void> => {
  if (isOpenRoute(path)) {
    return;
  }

  const user = await fetchCurrentUser().catch(() => null);
  if (!user || !isApprovedUser(user)) {
    return;
  }

  if (!hasRouteAccess(path, user.permissions)) {
    throw redirect(RouteEnum.FORBIDDEN);
  }
};

export const contextMiddleware = (path: RouteEnum): MiddlewareFunction => {
  return async (_args, next) => {
    await assertRouteAccess(path);
    return next();
  };
};
